import { api } from './api';

const messageService = {
  // Get all conversations
  getConversations: async (page = 1, status = 'active') => {
    const response = await api.get('/messages/conversations', {
      params: { page, status }
    });
    return response.data;
  },

  // Get messages for a conversation
  getMessages: async (conversationId, page = 1) => {
    const response = await api.get(`/messages/conversations/${conversationId}/messages`, {
      params: { page }
    });
    return response.data;
  },

  // Create or get conversation
  createConversation: async (sessionId) => {
    const response = await api.post('/messages/conversations', { sessionId });
    return response.data;
  },

  // Send message
  sendMessage: async (conversationId, content, type = 'text', metadata = null) => {
    const response = await api.post('/messages/send', {
      conversationId,
      content,
      type,
      metadata
    });
    return response.data;
  },

  // Send location
  sendLocation: async (conversationId, latitude, longitude, address) => {
    const response = await api.post('/messages/location', {
      conversationId,
      latitude,
      longitude,
      address
    });
    return response.data;
  },

  // Mark messages as read
  markAsRead: async (messageIds) => {
    const response = await api.post('/messages/read', { messageIds });
    return response.data;
  },

  // Edit message
  editMessage: async (messageId, content) => {
    const response = await api.put(`/messages/${messageId}`, { content });
    return response.data;
  },

  // Delete message
  deleteMessage: async (messageId) => {
    const response = await api.delete(`/messages/${messageId}`);
    return response.data;
  },

  // Block/unblock conversation
  toggleBlock: async (conversationId) => {
    const response = await api.post(`/messages/conversations/${conversationId}/block`);
    return response.data;
  },

  // Get unread count
  getUnreadCount: async () => {
    const response = await api.get('/messages/unread-count');
    return response.data;
  }
};

export default messageService;